module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e2855"
    }
  }, [_c('span', [_c('i', [_vm._v("Contents ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2905"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c5_r1#d7e1",
      "id": "d6e1"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])]), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2955"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c6_r1#d7e2",
      "id": "d6e2"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART 1:")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DEA AND THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGACY ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3005"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c7_r1#d7e3",
      "id": "d6e3"
    }
  }, [_vm._v("Introduction ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3035"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c8_r1#d7e4",
      "id": "d6e4"
    }
  }, [_vm._v("Chapter 1: The Deadly Dissection ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3065"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c9_r1#d7e5",
      "id": "d6e5"
    }
  }, [_vm._v("Chapter 2: Perspectives ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3105"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c10_r1#d7e6",
      "id": "d6e6"
    }
  }, [_vm._v("Chapter 3: Fathers and Sons ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3135"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c11_r1#d7e7",
      "id": "d6e7"
    }
  }, [_vm._v("Chapter 4: Grandfather of Mirth and Gladness ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3165"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c12_r1#d7e8",
      "id": "d6e8"
    }
  }, [_vm._v("Chapter 5: Humor of the Self ")]), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3195"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c13_r1#d7e9",
      "id": "d6e9"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART 2:")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OY ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3245"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c14_r1#d7e10",
      "id": "d6e10"
    }
  }, [_vm._v("Introduction ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3285"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c15_r1#d7e11",
      "id": "d6e11"
    }
  }, [_vm._v("Chapter 6: "), _c('i', [_vm._v("Sehnsucht ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3355"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c16_r1#d7e12",
      "id": "d6e12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Joy and Suffering ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3385"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c17_r1#d7e13",
      "id": "d6e13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Laughter of Reunions ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3415"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c18_r1#d7e14",
      "id": "d6e14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Joy and Hierarchy ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3455"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c19_r1#d7e15",
      "id": "d6e15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: A Joyful Noise ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3485"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c20_r1#d7e16",
      "id": "d6e16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Laughter at Thanksgiving ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3515"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c21_r1#d7e17",
      "id": "d6e17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Heaven ")]), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3545"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c22_r1#d7e18",
      "id": "d6e18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART 3:")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UN ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3595"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c23_r1#d7e19",
      "id": "d6e19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3635"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c24_r1#d7e20",
      "id": "d6e20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: The Quiddity of Life ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3665"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c25_r1#d7e21",
      "id": "d6e21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Humor and Humility ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3695"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c26_r1#d7e22",
      "id": "d6e22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Gravity and Levity ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3725"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c27_r1#d7e23",
      "id": "d6e23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Food and Drink ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3806"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c28_r1#d7e24",
      "id": "d6e24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Adventures and Games ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3836"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c29_r1#d7e25",
      "id": "d6e25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: The Fun in Nature ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3866"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c30_r1#d7e26",
      "id": "d6e26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Wild Play ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3896"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c31_r1#d7e27",
      "id": "d6e27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: The Fun of Reading ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3926"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c32_r1#d7e28",
      "id": "d6e28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Wordplay ")]), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3956"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c33_r1#d7e29",
      "id": "d6e29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART 4:")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OKE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPER ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4016"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c34_r1#d7e30",
      "id": "d6e30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4046"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c35_r1#d7e31",
      "id": "d6e31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Wit and Wordplay ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4076"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c36_r1#d7e32",
      "id": "d6e32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: The Word Made Joke ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4106"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c37_r1#d7e33",
      "id": "d6e33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: Comic Techniques and Topics ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4136"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c38_r1#d7e34",
      "id": "d6e34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Taboo Humor ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4176"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c39_r1#d7e35",
      "id": "d6e35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: The Vernacular and the Vulgar ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4206"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c40_r1#d7e36",
      "id": "d6e36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: The Oldest Joke ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4236"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c41_r1#d7e37",
      "id": "d6e37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: Falling from "), _c('i', [_vm._v("Frauendienst ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4306"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c42_r1#d7e38",
      "id": "d6e38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: Sex and Marriage ")]), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4346"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c43_r1#d7e39",
      "id": "d6e39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART 5:")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATIRE AND")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LIPPANCY ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4396"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c44_r1#d7e40",
      "id": "d6e40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4426"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c45_r1#d7e41",
      "id": "d6e41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: A Storehouse of Satire ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4456"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c46_r1#d7e42",
      "id": "d6e42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31: The Sword of Satire ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4486"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c47_r1#d7e43",
      "id": "d6e43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32: Flippancy ")]), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4526"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c48_r1#d7e44",
      "id": "d6e44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART 6:")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCLUSION: ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUGHTER OF")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVE ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4576"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c49_r1#d7e45",
      "id": "d6e45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33: A Divine Comedy ")]), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4606"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d7e46",
      "id": "d6e46",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4656"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c51_r1#d7e47",
      "id": "d6e47",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4716"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c52_r1#d7e48",
      "id": "d6e48",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4766"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c53_r1#d7e49",
      "id": "d6e49",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-536bc6b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lind_9781595554796_epub_c4_r1.vue
// module id = 66
// module chunks = 0